<div>
  <div class="dialog-header">
    <h4 mat-dialog-title>Delete repository</h4>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="warning-header">
      <p>
        Are you sure you want to delete the repository
        <span class="repo-name-span">{{ data.repoName }}</span
        >?
      </p>
    </div>

    <p class="description">
      This action will permanently delete the repository layers (not the statistics) from:
    </p>
    <ul class="database-list">
      <li>PostGIS database</li>
    </ul>

    <p class="description">
      The repository layers will also be <strong>uncloned</strong> from the local system.
    </p>

    <p class="description">Note: The delete on the GeoServer hasn't been implemented yet.</p>

    <div class="action-warning-div">
      <mat-icon>warning</mat-icon>
      This action cannot be undone. If the repository contains multiple layers, all of them will be
      deleted.
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    @if (isLoading$()) {
      <mat-icon><mat-spinner diameter="20"></mat-spinner></mat-icon>
    }
    <button matButton="outlined" type="button" [disabled]="isLoading$()" mat-dialog-close>
      Cancel
    </button>
    <button
      matButton="filled"
      class="warn-button"
      (click)="deleteRepoIntegration()"
      [disabled]="isLoading$()"
    >
      Yes I'm sure.
    </button>
  </mat-dialog-actions>
</div>
